export const services = [
  {
    id: 1,
    title: "Fire Risk Assessment",
    description: "Comprehensive evaluation of fire hazards, escape routes, and compliance gaps for SCDF certification.",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/94b3b65e-9bbc-4a25-aa9a-074e5570849d_compressed_Depositphotos_81678590_l-2015.webp",
    icon: "ri-fire-line",
  },
  {
    id: 2,
    title: "Fire Alarm Systems",
    description: "Design, installation, and maintenance of addressable and conventional fire alarm systems for all building types.",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/1720140f-234c-4e95-86ec-b8ca419e1fef_compressed_Depositphotos_12381850_l-2015.webp",
    icon: "ri-alarm-warning-line",
  },
  {
    id: 3,
    title: "Fire Suppression Systems",
    description: "Sprinkler, gas suppression, and foam-based solutions tailored to your property's unique fire protection needs.",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/c4aa6b40-e498-4bd3-b4b7-45d6fecf0b37_compressed_Depositphotos_48431303_l-2015.webp",
    icon: "ri-shield-check-line",
  },
  {
    id: 4,
    title: "Emergency Lighting",
    description: "Exit signs, egress lighting, and photoluminescent marking systems for safe evacuation during emergencies.",
    image: "https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/9f7f300b-0a9b-4a7e-882a-38677435273a_compressed_1b3d6e52-36b7-4437-bcf8-f1c3bf9a47df.webp",
    icon: "ri-lightbulb-flash-line",
  },
];

export const testimonials = [
  {
    id: 1,
    quote: "Ezzogenics handled our full building fire safety assessment with exceptional professionalism. Their SCDF compliance guidance saved us from costly penalties and gave us complete peace of mind.",
    author: "Sarah Lim",
    role: "Facility Manager, Marina Bay Commercial Tower",
  },
  {
    id: 2,
    quote: "The team installed our new addressable fire alarm system in just 3 days with minimal disruption to our operations. Their technicians were knowledgeable, punctual, and thorough.",
    author: "David Chen",
    role: "Operations Director, Jurong Logistics Hub",
  },
  {
    id: 3,
    quote: "We submitted our fire safety plans through their document upload portal and received SCDF approval within 2 weeks. Fast, efficient, and hassle-free service.",
    author: "Amira Hassan",
    role: "Project Manager, Tampines Residential Development",
  },
];

export const faqs = [
  {
    id: 1,
    question: "How often is a fire risk assessment required in Singapore?",
    answer: "Under the Singapore Civil Defence Force (SCDF) regulations, fire risk assessments must be conducted annually for commercial and industrial buildings. Residential buildings under the Management Corporation Strata Title (MCST) are also required to conduct assessments every 2 years. Our team ensures your assessment meets all current SCDF and BCA requirements.",
  },
  {
    id: 2,
    question: "What documents do I need to submit for SCDF fire safety approval?",
    answer: "Required documents include: (1) Fire Safety Plan drawings showing escape routes, fire compartmentation, and fire-fighting provisions; (2) Fire Engine Access Route plans; (3) Material specifications for fire-rated doors and partitions; (4) Calculation sheets for occupant load and fire resistance ratings; (5) QP endorsement for structural fire safety. Upload all documents through our contact form for review.",
  },
  {
    id: 3,
    question: "How long does it take to install a fire alarm system in a commercial building?",
    answer: "Installation timelines vary by building size and system complexity. A small office (under 500 sqm) typically takes 2-3 days, while a large commercial complex may require 2-3 weeks. We provide detailed project timelines after the initial site survey and always work to minimize disruption to your daily operations.",
  },
  {
    id: 4,
    question: "Are your fire safety services SCDF-approved and BCA-registered?",
    answer: "Yes, Ezzogenics is fully SCDF-registered and BCA-licensed. All our fire safety engineers and technicians hold relevant certifications including Fire Safety Manager accreditation, and our installations comply with SS CP 10 (Singapore Standard Code of Practice for Fire Alarm Systems) and SS 530 (Fire Extinguishing Systems).",
  },
  {
    id: 5,
    question: "What areas in Singapore do you service?",
    answer: "We provide fire safety services across all districts in Singapore, including the Central Business District (CBD), Orchard, Tampines, Jurong, Woodlands, and all industrial estates. Our team is strategically located to respond to service calls across the island within 24 hours for emergency situations.",
  },
];

export const stats = [
  { value: "12+", label: "Years in Operation" },
  { value: "850+", label: "Projects Completed" },
  { value: "100%", label: "SCDF Compliance Rate" },
  { value: "24h", label: "Emergency Response" },
];